import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiActivity, FiUserCheck, FiAward, FiUsers, FiTrendingUp, FiBook, FiGlobe, FiCheckCircle } = FiIcons;

const QuickFacts = () => {
  const facts = [
    { label: "Experience", value: "17 Years", sub: "Teaching Globally", icon: FiActivity, color: "text-blue-500" },
    { label: "Students", value: "50k+", sub: "Enrolled Worldwide", icon: FiUsers, color: "text-green-500" },
    { label: "Courses", value: "20+", sub: "Premium Content", icon: FiBook, color: "text-yellow-500" },
    { label: "Satisfaction", value: "4.9/5", sub: "Student Rating", icon: FiUserCheck, color: "text-purple-500" },
    { label: "Success Rate", value: "98%", sub: "Exam Pass Rate", icon: FiTrendingUp, color: "text-red-500" },
    { label: "Reach", value: "100+", sub: "Countries Served", icon: FiGlobe, color: "text-orange-500" },
    { label: "Certificates", value: "15k+", sub: "Issued to Date", icon: FiAward, color: "text-pink-500" },
    { label: "Support", value: "24/7", sub: "Live Chat", icon: FiCheckCircle, color: "text-teal-500" },
  ];

  return (
    <section className="py-20 px-4 bg-zinc-900 border-t border-zinc-800">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-5xl font-black text-white mb-4 uppercase">
            Why <span className="text-yellow-500">Choose Us</span>
          </h2>
          <p className="text-gray-400">The numbers speak for themselves.</p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {facts.map((fact, i) => (
            <div key={i} className="bg-black p-6 rounded-2xl border border-zinc-800 hover:border-yellow-500/50 transition-all group">
              <SafeIcon icon={fact.icon} className={`text-3xl mb-4 group-hover:scale-110 transition-transform ${fact.color}`} />
              <div className="text-3xl font-black text-white mb-1">{fact.value}</div>
              <div className="text-sm font-bold text-yellow-500 uppercase tracking-wider mb-1">{fact.label}</div>
              <div className="text-xs text-gray-500">{fact.sub}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default QuickFacts;